import { Component, inject, input, output } from '@angular/core';
import { TextLinkModule, TextLinkSizeEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/text-link';
import { BookingType } from 'app/views/booking-list/models/booking-type';
import { Observable, take } from 'rxjs';
import { BookingsResponse } from '../../models/bookings.interface';
import { ExportExtensions, textLinkConfiguration } from '../../models/export-booking-list.model';
import { BookingListService } from '../../services/booking-list.service';
import { ExportBookingListService } from '../../services/export-booking-list.service';

@Component({
  selector: 'app-export-booking-list',
  templateUrl: './export-booking-list.component.html',
  standalone: true,
  imports: [TextLinkModule]
})
export class ExportBookingListComponent {
  public typeBookings = input.required<BookingType>();

  public loading = output<boolean>();

  private readonly _exportBookingListService = inject(ExportBookingListService);
  private readonly _bookingListService = inject(BookingListService);

  public readonly iconSize = TextLinkSizeEnum.S;
  public readonly textLinkConfiguration = textLinkConfiguration;

  public exportBookingList(extension: ExportExtensions): void {
    this.loading.emit(true);
    this.getBookings$()
      .pipe(take(1))
      .subscribe(() => {
        this._exportBookingListService.exportBookingList(extension, this.typeBookings());
        this.loading.emit(false);
      });
  }

  private getBookings$(): Observable<BookingsResponse> {
    return this.typeBookings() === 'Standard'
      ? this._bookingListService.getAllBookings()
      : this._bookingListService.getAllCreditBookings();
  }
}
